<template>
  <div>
    <Article
    head_title1="Ihr Ratgeber für "
    head_title2="für den erfolgreichen Umzug"
    head_subtitle="Umzugsratgeber für die Planung und Durchführung von Umzügen."
    meta_title="Alles rund um den Umzug mit unserem Umzugsratgeber | umzug-bayern.com"
    page_title="Umzugsratgeber"
    :keywords="['Umzugsratgeber', 'Ratgeber', 'Tipps']"
    description="Entdecken Sie in unserem Umzugsratgeber wertvolle Tipps und Tricks, um Ihren Umzug stressfrei zu gestalten. Von der Planung bis zur Durchführung - wir zeigen Ihnen, wie Sie Ihren Umzug erfolgreich meistern und sich schnell in Ihrem neuen Zuhause einleben können."
    :share_buttons="true">
    <div class="bg-light py-4">
      <div class="container min-vh-100">
        <div class="row">
          <div v-for="post in posts" :key="post" class="mt-4">
            <BlogPostPreview
            :link="'/umzugsratgeber/'+ post.slug"
            :linktitle="post.title.rendered"
            textside="right"
            :imgsrc="(post._embedded['wp:featuredmedia'].length > 0)?post._embedded['wp:featuredmedia'][0].source_url:null"
            :imgalt="(post._embedded['wp:featuredmedia'].length > 0)?post._embedded['wp:featuredmedia'][0].alt_text:null"
            >
            <h2><a :title="post.title.rendered" :href="'/umzugsratgeber/'+ post.slug"><div v-html="post.title.rendered"></div></a></h2>
            <div v-html="post.excerpt.rendered"></div>
          </BlogPostPreview>

          </div>
        </div>
      </div>
    </div>
    </Article>
  </div>
</template>

<script>
// @ is an alias to /src
import Article from '@/components/Article.vue'
import BlogPostPreview from '@/components/BlogPostPreview.vue'

export default {
  name: 'Blog',
  components: {
    Article,
    BlogPostPreview
  },
  data: function() {
    return {
      posts: []
    }
  },
  mounted: function() {
    this.CmsApi.GetArticles().then((data) => {
      if(data != null) {
        this.posts = data
      }
    }).catch(() => {
      // console.log(slug)
    })

  }
}
</script>
